import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from './Container';
import Text from './Text';
import NavMenuItem from './NavMenuItem';

const StyledNavMenuItem = styled(NavMenuItem)`
  border-bottom: 2px solid transparent;
  &.active {
    border-bottom-color: ${props => props.theme.tertiary.tertiary100};
  }
  &:hover {
    background-color: transparent;
  }
`;

const TabItem = ({ text, ...props }) => {
  return (
    <StyledNavMenuItem marginHorizontal="small" {...props}>
      <Container paddingBottom="small">
        <Text whiteSpace="nowrap">{text}</Text>
      </Container>
    </StyledNavMenuItem>
  );
};

TabItem.propTypes = {
  text: PropTypes.string,
};

TabItem.defaultProps = {
  text: null,
};

export default TabItem;
